<section id="schedaPartner" class="content-padding darker">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="_userForm" (ngSubmit)="onSubmit()" *ngIf="_userForm">

      <!-- <div class="expert-personal-info" *ngIf="isProductionServer"> -->
      <div class="expert-personal-info">
        <fieldset>
          <legend>QONTO CONNECTION:</legend>
          <div class="col-48 grid-element">
            <button 
              class="btn hvr-grow has-margin-right" 
              type="button" 
              (click)="connectWithQonto($event)"
              [disabled]="disableBtn"
            >
              Connect With Qonto
            </button>
          </div>
        </fieldset>
        <br class="clear"> 
      </div>

      <div class="expert-personal-info">
        <fieldset>
          <legend>PERSONAL INFORMATION:</legend>
          <div class="col-48 grid-element">
            <label>E-mail{{ _userForm.get("email") | required }}</label>
            <input type="email" name="email" formControlName="email">
            <app-error-html-handler [ctrl]="_userForm.get('email')" [messages]="formValidationMsgs.email">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element">
            <label>Reclama Mail Valet{{ _userForm.get("valetComplainEmail") | required }}</label>
            <input type="valetComplainEmail" name="valetComplainEmail" formControlName="valetComplainEmail">
            <app-error-html-handler [ctrl]="_userForm.get('valetComplainEmail')" [messages]="formValidationMsgs.valetComplainEmail">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element">
            <label>Reclama Mail Partners{{ _userForm.get("partnerComplainEmail") | required }}</label>
            <input type="partnerComplainEmail" name="partnerComplainEmail" formControlName="partnerComplainEmail">
            <app-error-html-handler [ctrl]="_userForm.get('partnerComplainEmail')" [messages]="formValidationMsgs.partnerComplainEmail">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element">
            <label>Cognome{{ _userForm.get("surname") | required }}</label>
            <input type="text" name="surname" formControlName="surname">
            <app-error-html-handler [ctrl]="_userForm.get('surname')" [messages]="formValidationMsgs.surname">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element">
            <label>Nome{{ _userForm.get("name") | required }}</label>
            <input type="text" name="name" formControlName="name">
            <app-error-html-handler [ctrl]="_userForm.get('name')" [messages]="formValidationMsgs.name">
            </app-error-html-handler>
          </div>
          <br class="clear">
          <div class="col-48 grid-element" *ngIf="profile">
            <label>Password</label>
            <input type="password" name="password1" formControlName="password1">
            <app-error-html-handler [ctrl]="_userForm.get('password1')" [messages]="formValidationMsgs.password1">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element" *ngIf="profile">
            <label>Ripeti password</label>
            <input type="password" name="password2" formControlName="password2">
            <app-error-html-handler [ctrl]="_userForm.get('password2')" [messages]="formValidationMsgs.password2">
            </app-error-html-handler>
          </div>
          <br class="clear">
        </fieldset>
      </div>

      <div class="center mt-20">
        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()"
          [disabled]="!_userForm?.valid">
          Salva<i class="ml-10 far fa-save"></i>
        </button>
      </div>
    </form>
    <br class="clear">
  </div>
</section>
